//This file can be used to define permissions for various features in the application based on uid

const MULTI_SURVEYOR_ENABLED_CLIENT_IDS = [
  'nlanarkshireschools',
  'tetratechfcdo',
  'rlbmanchesterroyalinfirmary',
  'bamfmsurveys',
  'dpnt',
  'modschoolexeter',
  'tynewearfirerescue',
  'aes-nottinghamcollege',
  'astonuniversity',
  'universityofbirmingham',
  'rlbpyramidschoolshadley',
  'rlbbristolcitycouncil',
];

export const PERMISSIONS = {
  BULK_UPLOADING: [
    //jon.cooper@uk.rlb.com
    'ycZAQkldFmPIt8YGrIwtaaEjus33',
    //georgina.freeman@uk.rlb.com
    'c8DmcUssA1a7ftXZyfCmB8vNyDd2',
    //test user (local dev)
    'QsQ6s00UMS2G7KqoUNtr9aBYVgRJ',
  ],
  MULTI_SURVEYOR_VIEW_CLIENT_IDS: MULTI_SURVEYOR_ENABLED_CLIENT_IDS,
  MULTI_SURVEYOR_MANAGE_CLIENT_IDS: MULTI_SURVEYOR_ENABLED_CLIENT_IDS,
};
